const resolveElements = () => {
  return new Promise(resolve => {
      requestAnimationFrame(resolve); //faster than set time out
  });
}

export const CheckElements = selector => {
  if (!document.querySelectorAll(selector).length)
      return resolveElements().then(() => CheckElements(selector));
  
  else return Promise.resolve(document.querySelectorAll(selector));
}

export const IsEmpty = val => {
  return (val === undefined || val == null || val.length <= 0) ? true : false;
}
